import { render, staticRenderFns } from "./IconGithub.vue?vue&type=template&id=59239703&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IconGithub.vue"
export default component.exports